import React from 'react';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { Loader2, Mail } from 'lucide-react';

/* Zero-link nudge conversion insights */
export const AdminNudgesTab = ({ nudges, loading }) => {
  if (loading || !nudges) {
    return (
      <div className="flex justify-center py-20">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  const stats = [
    { label: 'Nudges sent', value: nudges.sent },
    { label: 'Added a link after', value: nudges.added_link },
    { label: 'Bought Pro', value: nudges.went_pro },
    { label: 'Link conversion', value: `${nudges.conversion_pct}%` },
  ];

  return (
    <div className="space-y-6" data-testid="admin-nudges-tab">
      <div className="flex items-center gap-2">
        <Mail className="w-5 h-5 text-primary" />
        <h2 className="text-lg font-semibold">Zero-link nudges</h2>
      </div>
      <p className="text-sm text-muted-foreground -mt-3">
        One friendly email from Brian, 48 hours after signup, to anyone who still has no links.
      </p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {stats.map((s) => (
          <Card key={s.label} className="p-5" data-testid={`nudge-stat-${s.label.toLowerCase().replace(/\s/g, '-')}`}>
            <p className="text-xs text-muted-foreground uppercase tracking-wider mb-1">{s.label}</p>
            <p className="text-3xl font-bold tabular-nums">{s.value}</p>
          </Card>
        ))}
      </div>

      <Card className="p-6" data-testid="nudge-recipients-card">
        <p className="text-sm font-semibold mb-4">Recipients ({nudges.recipients.length})</p>
        {nudges.recipients.length === 0 ? (
          <p className="text-sm text-muted-foreground py-8 text-center">
            No nudges sent yet — the first ones go out 48 hours after a zero-link signup.
          </p>
        ) : (
          <div className="space-y-2">
            {nudges.recipients.map((r) => (
              <div key={r.email} className="flex items-center justify-between gap-3 p-3 rounded-lg border border-border bg-muted/30 flex-wrap" data-testid={`nudge-recipient-${r.username}`}>
                <div className="min-w-0">
                  <p className="text-sm font-medium truncate">{r.name} <span className="text-muted-foreground">@{r.username}</span></p>
                  <p className="text-xs text-muted-foreground truncate">{r.email} · nudged {r.sent_at ? new Date(r.sent_at).toLocaleDateString() : '—'}</p>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  {r.is_pro && (
                    <Badge className="bg-[#0055FF] text-white hover:bg-[#0055FF]" data-testid={`nudge-pro-badge-${r.username}`}>
                      PRO{r.billing_cycle ? ` · ${r.billing_cycle}` : ''}
                    </Badge>
                  )}
                  {r.added_link ? (
                    <Badge className="bg-emerald-500 text-white hover:bg-emerald-500">
                      {r.links_count} link{r.links_count === 1 ? '' : 's'} added
                    </Badge>
                  ) : (
                    <Badge variant="secondary">Still 0 links</Badge>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
};
